import { getUserDetails, updateUser } from "../../services/Users-services";
import React, { useEffect, useState } from "react";
import { showErrorMessages } from "../../services/utilityFunctions";
import { useNavigate } from "react-router-dom";
import { FiUser, FiCalendar, FiEdit, FiMoreVertical } from "react-icons/fi";
import { MdSupervisorAccount } from "react-icons/md";
import { Card, Col, Row, Badge } from "react-bootstrap";
import DetailsPageNavigation from "../../views/dashboard/widget/detailsPageNavigation";
import MasterActions from "../../views/dashboard/widget/MasterActions";
import {
  deleteUser,
  updateStatus,
  editUser,
} from "../../services/Users-services";
import placeHolder from "../../assets/images/placeHolderProfile.jpg";
import { getMethods } from "../../services/utilityFunctions";
import { useParams } from "react-router-dom";
import { getLocalStorageData } from "../../services/axiosComponent";

const UserDetails = ({ id }) => {
  var { id } = useParams();
  const userId = getLocalStorageData("profileDetails")._ID;
  const navigate = useNavigate();
  const [methods, setMethods] = useState({});
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ status: false, message: "" });
  const getUserDetailsData = async (id) => {
    setLoading(true);
    var res = await getUserDetails(id);
    if (res.status == "success") {
      setMethods(getMethods("User Management", "Users"));
      console.log(res.data, "res.data");
      console.log("res.data", userId);
      setDetails(res.data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoading(false);
  };
  useEffect(() => {
    getUserDetailsData(id);

    return () => {};
  }, []);

  return loading ? (
    <center>
      <div class="spinner-border text-primary" role="status">
 
      </div>
    </center>
  ) : (
    <Row className="mb-3">
      <Row className="mb-1  pb-0">
        <Col lg="12" className="mb-0 pb-0 ">
          <Card
            className="position-relative border-0  transition-all "
            style={{ borderRadius: "1rem", transition: "0.3s" }}
          >
            <Card.Body className="p-3 px-lg-4 py-lg-3">
              <div className="row g-3 align-items-start">
                {/* Left Section */}
                <div className="">
                  <Row className="">
                    <Col className="">
                      <DetailsPageNavigation list={["Users", "Details"]} />
                      <Col
                        lg="12"
                        className="pe-0 me-0 d-flex align-items-center gap-4"
                      >
                        <div className="d-flex align-items-center gap-3 flex-column">
                          <div
                            className="rounded-3 overflow-hidden"
                            style={{
                              height: "17vh",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid rgba(0,0,0,0.05)",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                              width: "100%", // ensure container spans full width if needed
                            }}
                          >
                            <img
                              src={details?.IMAGE_URL || placeHolder}
                              alt={details["NAME"]}
                              className="w-100 h-100 object-fit-cover"
                              onError={(e) => {
                                e.target.src = placeHolder;
                              }}
                            />
                          </div>

                          <Badge
                            bg=""
                            style={{
                              width: "70px",
                              padding: "4px 7px",
                              fontSize: "0.75rem",
                              fontWeight: "400",
                              backgroundColor:
                                details?.["STATUS"] === "Y"
                                  ? "#e8f5e9"
                                  : "#ffebee",
                              color:
                                details?.["STATUS"] === "Y"
                                  ? "#2e7d32"
                                  : "#c62828",
                              borderRadius: "4px",
                              textTransform: "uppercase",
                              letterSpacing: "0.4px",
                            }}
                          >
                            {details?.["STATUS"] === "Y"
                              ? "Active"
                              : "Inactive"}
                          </Badge>
                        </div>

                        <div className="d-flex flex-column gap-2">
                          <h3
                            className="mb-0 fw-bold fs-4 text-truncate"
                            style={{
                              background:
                                "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                            }}
                          >
                            {details["NAME"]}
                          </h3>

                          {details["ORGANIZATION LEVEL"] && (
                            <div className="d-flex align-items-center gap-2">
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: 28, height: 28 }}
                              >
                                <MdSupervisorAccount className="text-primary fs-6" />
                              </div>
                              <div
                                className="text-dark fw-medium"
                                style={{ fontSize: "0.875rem" }}
                              >
                                {details["ORGANIZATION LEVEL"]}
                              </div>
                            </div>
                          )}

                          {details["DEPARTMENT LEVEL"] && (
                            <div className="d-flex align-items-center gap-2">
                              <div
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: 28, height: 28 }}
                              >
                                <FiUser className="text-primary fs-6" />
                              </div>
                              <div
                                className="text-dark fw-medium"
                                style={{ fontSize: "0.875rem" }}
                              >
                                {details["DEPARTMENT LEVEL"]}
                              </div>
                            </div>
                          )}
                        </div>
                      </Col>
                    </Col>

                    <Col lg="3" className="h-100">
                      <div className="h-100">
                        <div
                          className="d-flex flex-column justify-content-between"
                          style={{ minHeight: "17vh" }}
                        >
                          {/* User Info */}
                          <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                flexShrink: 0,
                              }}
                            >
                              <FiUser
                                className="text-primary"
                                style={{
                                  fontSize: "clamp(0.75rem, 1.5vw, 1rem)",
                                }}
                              />
                            </div>
                            <div
                              className="text-dark fw-medium"
                              style={{
                                fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                              }}
                            >
                              {details["CREATED BY"]}
                            </div>
                          </div>

                          {/* Last Modified */}
                          <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                flexShrink: 0,
                              }}
                            >
                              <FiCalendar
                                className="text-success"
                                style={{
                                  fontSize: "clamp(0.75rem, 1.5vw, 1rem)",
                                }}
                              />
                            </div>
                            <div
                              className="text-dark fw-medium"
                              style={{
                                fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                              }}
                            >
                              {details["LAST MODIFIED"]}
                            </div>
                          </div>

                          {/* Modified By */}
                          <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                            <div
                              className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                              style={{
                                width: "2rem",
                                height: "2rem",
                                flexShrink: 0,
                              }}
                            >
                              <FiEdit
                                className="text-warning"
                                style={{
                                  fontSize: "clamp(0.75rem, 1.5vw, 1rem)",
                                }}
                              />
                            </div>
                            <div
                              className="text-dark fw-medium"
                              style={{
                                fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                              }}
                            >
                              {details["MODIFIED BY"]}
                            </div>
                          </div>

                          {/* Actions */}
                          {
                            <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                              <div
                                className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                                style={{
                                  width: "2rem",
                                  height: "2rem",
                                  flexShrink: 0,
                                }}
                              >
                                <MasterActions
                                  actions={{
                                    edit: true,
                                    delete: true,
                                    status: true,
                                  }}
                                  methods={methods}
                                  deleteRow={deleteUser}
                                  updateStatus={updateStatus}
                                  updateRow={updateUser}
                                  isDetailsPage={true}
                                  item={details}
                                  refresh={() => getUserDetailsData(id)}
                                />
                              </div>
                              <div
                                className="text-dark fw-medium"
                                style={{
                                  fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                                }}
                              >
                                Show Options
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* Right Section */}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-0">
        <Col lg="8"></Col>
        <Col lg="4"></Col>
      </Row>
    </Row>
  );
};

export default UserDetails;
